import React from "react";
import moment from "moment";
import { Loading } from '../../../../../components';
import { CalendarOutlined, EditOutlined, UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, Empty, Row, Space, Switch, Typography } from "antd"
const { Text } = Typography;

const DetailTicket = ({ dataTicket, showModal, handleSwitch, showModalPayment  }) => {
  if(dataTicket.loading){
    return <Loading />
  }

  return(
    <Card
      style={{ border: 'none' }}
      bordered={false}
      title={<Text strong>Tickets</Text>} 
      extra={<Button key="1" style={{ width: 90 }} className="btn-color-blue" type="primary" onClick={() => showModal('add')}>Add</Button>} 
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {
            dataTicket.data ?
              dataTicket.data.map((item, i) => (
                <React.Fragment>
                  <Card key={i} bordered={false} style={{ border: 'none', backgroundColor: '#d4dfef', borderRadius: '6px 6px 0 0' }}>
                    <Row justify="space-around" align="middle">
                      <Col span={20}>
                        <Text strong={true} align="middle" style={{ fontSize: 16 }}>{item.name ? item.name : 'N/A'}</Text>
                      </Col>
                      <Col span={4} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Switch size="small" checked={item.enabled} onChange={(check) => handleSwitch(check, item.id)} />
                        <EditOutlined style={{ fontSize: 20, cursor: 'pointer', color: '#32ab6d' }} onClick={() => showModal('edit', item)} />
                      </Col>
                    </Row>
                  </Card>
                  <Card
                  style={{ padding: 0, marginBottom: 15, borderRadius: '0 0 6px 6px', boxShadow: '1px 1px 12px #F2F2F2', border: 'none' }}
                  bodyStyle={{ padding: 16}}
                  >
                  <Row gutter={[16, 8]} justify="space-around" align="middle">
                    <Col span={8}>
                      <Space direction="vertical">
                        <Space size={'small'}>
                          <CalendarOutlined />
                          <Text type="secondary" style={{ fontSize: 13 }}>{moment(`${item.date}`, 'DD/MM/YYYY').format("DD MMMM YYYY")}</Text>
                        </Space>
                        {
                          item.totalQuota ? 
                            <Space size={'small'}>
                              <UserOutlined /> 
                              <Text type="secondary" style={{ fontSize: 13 }}>{`${item.totalQuota} People`}</Text>
                            </Space>
                          : null
                        }
                      </Space>
                    </Col>
                    <Col span={6}>
                      <Space direction="vertical">
                        <Text type="secondary">{`Sold : ${item.ticketSold || 0}`}</Text>
                      </Space>
                    </Col>
                    <Col span={6}>
                      <Space direction="vertical" size={0}>
                        {
                          item.discountedPrice ?
                            <>
                              <Text type="secondary" strong delete>{`IDR ${item.price.toLocaleString()}`}</Text>
                              <Text strong>{`IDR ${item.discountedPrice.toLocaleString()}`}</Text>
                            </>
                          : item.price ?
                            <Text strong>{`IDR ${item.price.toLocaleString()}`}</Text>
                          :
                            <Text strong>FREE</Text>
                        }
                      </Space>
                    </Col>
                    {/* <Col span={4} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Switch size="small" checked={item.enabled} onChange={(check) => handleSwitch(check, item.id)} />
                      <EditOutlined style={{ fontSize: 20, cursor: 'pointer', color: '#32ab6d' }} onClick={() => showModal('edit', item)} />
                    </Col> */}
                  </Row>
                  <Col>
                    <Space span={24}>
                      <Text className="fs-14 light-color">Payment Option</Text>
                      <InfoCircleOutlined style={{ color: 'blue' }} onClick={() => showModal('modalPayment', item)} />
                    </Space>
                  </Col>

                  </Card>

                </React.Fragment>

              
                
                
              ))
            :
            <React.Fragment>
              <Empty description={<Text>No Data Ticket</Text>} />
            </React.Fragment>
          }
        </Col>
      </Row>
    </Card>
  )
}

export default DetailTicket;